import { FileFilterKey } from '../domain';
import { useSetFilter } from '../../filter';

export const useSetFileFilter = () => {
  return useSetFilter(FileFilterKey, 'fileFilter', true);
};
